import { useAppSelector } from '@/Application/Hooks/Redux';
import {
  isDniFeatureEnabled,
  isDniRegisteredFeatureEnabled
} from '@/config/featureFlags';
import { NoviosFeedback } from '@/modules/perseo-billing/components';
import { CouponComponent } from '@/modules/perseo-billing/components/coupon-component/CouponComponent';
import {
  DeliveryTypes,
  ListOfPaymentMethods
} from '@/modules/perseo-billing/containers';
import { useMediaQuery } from '@/modules/perseo-billing/ui/react/src/ui-hooks/hook-useMediaQuery';
import { IdentificationDocumentTypes } from '@/modules/shared/types/IdentificationDocumentType';
import { useCustomerContext } from '@/sections/customer/CustomerContext';

import {
  PaymentSelectionSkeleton,
  SafePurchase,
  TitleAndInvoice
} from './components';

export const PaymentSection = () => {
  const { availablePayments } = useAppSelector((state) => state.billing);
  const shippingAddress = useAppSelector(
    (state) => state?.cart?.data?.shippingAddress
  );
  const {
    customer: { data: customer }
  } = useCustomerContext();
  const isPaymentReady = availablePayments;
  const isMobile = useMediaQuery('lg');

  // Determine if user is registered and check for foreign document
  const isRegistered = customer !== null;
  const isDniEnabled = isRegistered
    ? isDniRegisteredFeatureEnabled()
    : isDniFeatureEnabled();

  // For registered users, check customer.documentType; for guests, check shippingAddress.documentType
  const documentType = isRegistered
    ? customer?.documentType
    : shippingAddress?.documentType;

  const isForeignDocument =
    isDniEnabled && documentType === IdentificationDocumentTypes.DNI;

  return (
    <section className="co-flex co-flex-col co-flex-1 co-gap-32px lg:co-pl-16px lg:gap-48px co-px-16px">
      {isPaymentReady ? (
        <>
          <NoviosFeedback />
          <TitleAndInvoice isForeignDocument={isForeignDocument} />
          <ListOfPaymentMethods />
          {isMobile && <CouponComponent />}
          {isMobile && <DeliveryTypes />}
          <SafePurchase />
        </>
      ) : (
        <PaymentSelectionSkeleton />
      )}
    </section>
  );
};
